/**
 * Convert snake_case identifiers to title-case for display.
 * Used as a defensive fallback when an explicit display_name is missing,
 * so machine identifiers (e.g. "map_support") don't leak to end-users.
 *
 * humanizeKey('map_support')   // -> 'Map Support'
 * humanizeKey('color_display') // -> 'Color Display'
 * humanizeKey('')              // -> ''
 */
export function humanizeKey(key: string | null | undefined): string {
  return String(key || '')
    .split('_')
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
